import React, { useState } from "react";
 import SEO from "../components/seo";

// Blog data
const blogData = [
  {
    id: 1,
    title: "High-Quality Copper Products in Industry",
    author: "admin",
    date: "November 25, 2025",
    category: "Copper Fitting",
    image: "/static/img/portfolio/Product_Y.webp",
    description: "High-quality copper products deliver exceptional conductivity, durability, and reliability, making them essential for efficient performance in modern industrial applications.",
    link: "/blog-single"
  },
  {
    id: 2,
    title: "High-Quality Copper Products in Industry",
    author: "admin",
    date: "November 25, 2025",
    category: "Copper Fitting",
    image: "/static/img/portfolio/Product_Y.webp",
    description: "High-quality copper products deliver exceptional conductivity, durability, and reliability, making them essential for efficient performance in modern industrial applications.",
    link: "/blog-single"
  },
  // {
  //   id: 3,
  //   title: "Optimizing Last-Mile Delivery: Strategies for Success",
  //   author: "Henry Nicolls",
  //   date: "March 21, 2024",
  //   category: "Transport & Logistics",
  //   image: "/static/img/blog/ca-blog-1.2.webp",
  //   description: "Delve into the challenges of last-mile delivery and explore strategies to overcome them.",
  //   link: "/blog-single"
  // },
  // {
  //   id: 4,
  //   title: "Handling Project Cargo: Expert Tips and Strategies",
  //   author: "Henry Nicolls",
  //   date: "March 20, 2024",
  //   category: "Transport & Logistics",
  //   image: "/static/img/blog/ca-blog-1.3.webp",
  //   description: "Get expert tips on managing project cargo logistics. From planning and coordination.",
  //   link: "/blog-single"
  // },
];

// Reusable BlogCard component
const BlogCard = ({ blog }) => (
  
  <div className="col-xl-4 col-md-6 mb-30">
    <div className="ca-team-box ca-blg-box-3 cream-bg-3 br-7 fix p-relative z-index-1">
      <div className="ca-team-img">
        <img className="w-100" src={blog.image} alt={blog.title} />
      </div>
      <div className="ca-blog-date-3 ca-blg-date-3">
        <a href="#" className="blg-date-3">{blog.date}</a>
      </div>
      <div className="ca-blog-box-content ca-blog-box-content-3">
        <div className="ca-b-meta">
          <a href="#" className="ca-blog-meta ca-blog-meta-3">
            <div className="ca-meta-icon">
              <span>
                <img src="/static/img/icon/user-1.1.svg" alt="author" />
              </span>
            </div>
            <div className="ca-meta-title">
              <span>{blog.author}</span>
            </div>
          </a>
          <a href="#" className="ca-blog-meta ca-blog-meta-3">
            <div className="ca-meta-icon">
              <span>
                <img src="/static/img/icon/tag-1.1.svg" alt="category" />
              </span>
            </div>
            <div className="ca-meta-title">
              <span>{blog.category}</span>
            </div>
          </a>
        </div>
        <h4 className="ca-blog-title ca-blog-title-3 fnw-600">
          <a href={blog.link}>{blog.title}</a>
        </h4>
        <p className="pt-16 pb-18">{blog.description}</p>
        <div className="blog-3-rearmore">
          <a href={blog.link} className="read-more3">
            Read More <span><i className="fa-solid fa-angle-right" /></span>
          </a>
        </div>
      </div>
    </div>
  </div>
);

// Main Blog component
const Blog = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 3;

  // Pagination calculation
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogData.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogData.length / blogsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" }); // scroll to top on page change
  };

  return (
    <>
    <SEO pageKey="blog" />
    <main>

       {/* breadcrumb area start */}
  <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
    <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
      <img
        src="/static/img/shape/breadcrumn-shape.webp"
        alt=""
      />
    </div>
    <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
      <img src="/static/img/shape/ca-line-shape.webp" alt="" />
    </div>
    <div className="container">
      <div className="ca-breadcrumb-content text-center">
        <h2 className="ca-breadcrumb-title fnw-600">Our Blog</h2>
        <div className="it-breadcum-link">
          <a href="/">Home</a>
          <span>
            <i className="fa-solid fa-angle-right" />
          </span>
          <a className="active" href="#">
            Our Blog
          </a>
        </div>
      </div>
    </div>
  </section>
      {/* Blog Section */}
      <div className="ca-blog-inner pt-100 pb-100">
        <div className="container">
          <div className="row">
            {currentBlogs.map(blog => <BlogCard key={blog.id} blog={blog} />)}
          </div>

          {/* Pagination */}
          {/* <div className="row">
            <div className="col-12 m-auto">
              <div className="theme-pagination text-center">
                <ul>
                  <li>
                    <button onClick={() => handlePageClick(Math.max(currentPage - 1, 1))}>
                      <i className="fa-solid fa-angle-left" />
                    </button>
                  </li>
                  {[...Array(totalPages)].map((_, i) => (
                    <li key={i}>
                      <button
                        className={currentPage === i + 1 ? "active" : ""}
                        onClick={() => handlePageClick(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                  <li>
                    <button onClick={() => handlePageClick(Math.min(currentPage + 1, totalPages))}>
                      <i className="fa-solid fa-angle-right" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div> */}
           <div className="row">
          <div className="col-12 m-auto">
            <div className="theme-pagination text-center">
              <ul>
                <li>
                  <a onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}>
                    <i className="fa-solid fa-angle-left"></i>
                  </a>
                </li>

                {[...Array(totalPages)].map((_, index) => (
                  <li key={index}>
                    <a
                      className={currentPage === index + 1 ? "active" : ""}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {String(index + 1).padStart(2, "0")}
                    </a>
                  </li>
                ))}

                <li>
                  <a
                    onClick={() =>
                      currentPage < totalPages && setCurrentPage(currentPage + 1)
                    }
                  >
                    <i className="fa-solid fa-angle-right"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        </div>
      </div>
    </main>
    </>
  );
};

export default Blog;
